import { useClipboard } from 'root/src/client/web/hooks/useClipboard'
import { useCallback } from 'react'

export const CopyToClipboardBase = ({ children, text, onCopied, ...props }) => {
	const { writeText } = useClipboard()

	const onClick = useCallback(async (event) => {
		event.preventDefault()
		await writeText(text)

		if (onCopied) {
			onCopied(event, text)
		}
	}, [text, writeText])

	return (
		<button
			{...props}
			style={{ border: 'none', background: 'none', cursor: 'pointer' }}
			onClick={onClick}
			type="button"
		>
			{children}
		</button>
	)
}
